export default __webpack_public_path__ + "static/schemas-aa777a5c55c4ef0ea837de60204dc773.png";